import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Button, Divider } from 'antd';
import { APPOINTMENT_TYPE } from '../../../config/constants';
import AppointmentHeader from '../../../components/mobile/appointment/AppointmentHeader';
import AppointmentItem from '../../../components/mobile/appointment/AppointmentItem';
import AppointmentEmpty from '../../../components/mobile/appointment/AppointmentEmpty';
import { ReactComponent as CalendarSvg } from '../../../assets/icons/appointment/calendar.svg';
import { ReactComponent as CheckCircle } from '../../../assets/icons/appointment/check-circle.svg';
import { getAppointmentListAPICall } from '../../../api/appointment';

function MobileAppointmentScreen() {
  const { t } = useTranslation(['appointment', 'common']);
  const [upComingAppointments, setUpcomingAppointments] = useState([]);
  const [pastAppointments, setPastAppointments] = useState([]);
  const history = useHistory();

  const fetchUpComingAppointments = async () => {
    const { responseStatus, responseJSON } = await getAppointmentListAPICall(APPOINTMENT_TYPE.upcoming)
    if (responseStatus >= 200 && responseStatus < 300) {
      setUpcomingAppointments(responseJSON.results)
    } else {
      console.log(responseStatus)
    }
  }

  const fetchPastAppointments = async () => {
    const { responseStatus, responseJSON } = await getAppointmentListAPICall(APPOINTMENT_TYPE.past)
    if (responseStatus >= 200 && responseStatus < 300) {
      setPastAppointments(responseJSON.results)
    } else {
      console.log(responseStatus)
    }
  }

  useEffect(() => {
    fetchUpComingAppointments();
    fetchPastAppointments();
  }, []);

  const showDetailAppointment = (guid) => {
    history.push(`/appointment/detail/${guid}`)
  }

  return (
    <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
      <Box marginBottom={34}>
        <AppointmentHeader
          icon={<CalendarSvg />}
          title={t('appointment:home.upcoming')}
        />
        {
          upComingAppointments.length === 0
          ? <AppointmentEmpty title={t('appointment:home.emptyUpcoming')} />
          : (
            <Box style={{ padding: 0, marginTop: 25, marginBottom: 25 }}>
              {upComingAppointments.map((appointment) => <AppointmentItem doctor={appointment.doctor_name} date={appointment.appointment_date} time={appointment.appointment_date} onClick={() => showDetailAppointment(appointment.guid)} />)}
            </Box>
          )
        }
        {/* {
          upComingAppointments.length > 0 && (
            <Box>
              <Row justify="center">
                <Button type="link">{t('common:button.viewAll')}</Button>
              </Row>
            </Box>
          )
        } */}
      </Box>
      <Divider />
      <Box marginBottom={34}>
        <AppointmentHeader
          icon={<CheckCircle />}
          title={t('appointment:home.past')}
        />
        {
          pastAppointments.length === 0
          ? <AppointmentEmpty title={t('appointment:home.emptyUpcoming')} />
          : (
            <Box style={{ padding: 0, marginTop: 25, marginBottom: 25 }}>
              {pastAppointments.map((appointment) => <AppointmentItem doctor={appointment.doctor_name} date={appointment.appointment_date} time={appointment.appointment_date} onClick={() => showDetailAppointment(appointment.guid)} />)}
            </Box>
          )
        }
        {/* {
          pastAppointments.length > 0 && (
            <Box>
              <Row justify="center">
                <Button type="link">{t('common:button.viewAll')}</Button>
              </Row>
            </Box>
          )
        } */}
      </Box>
    </Box>
  );
}

export default MobileAppointmentScreen;
